import { Menu,Transition  } from "@headlessui/react"
import React, { useState } from "react"
 
import { IoIosSearch } from "react-icons/io";





interface InputFieldProps {
   placeholder: string;
   onchange:any;
   value:string;
  }

 
const SearchBar : React.FC<InputFieldProps> =({
    
  placeholder,
  value,
  onchange
 
} )=>{

 
  const [focused, setfocused] = useState(false);



  
    return (<>
      <div
        className={`flex justify-center items-center border-2 ${
          focused ? " border-primary shadow" : " border-gray-200shadow "
        }  bg-white rounded-lg `}
      >

        <IoIosSearch size={20} className="ml-4 text-textbg"/>
        <input
          type={"text"}
          value={value}
          onFocus={() => {
            setfocused(true);
          }}
          onBlur={() => {
            setfocused(false);
          }}
          placeholder={placeholder}
          onChange={(e) => {
            onchange(e.target.value);
          }}
          
          className={` block bg-white text-xs py-3 custom-outline	px-4 rounded-lg   w-full shadow-xs text-textbg ` }
         />
        
      </div>
    

</>)}

export {SearchBar}